<template>
  <div class="customer">
    <div class="customer-left">
      <div class="customer-tab">订单列表</div>
      <div>
        <el-input
          placeholder="请输入订单号"
          prefix-icon="el-icon-search"
          @keyup.enter.native="search"
          v-model="queryValue">
        </el-input>
      </div>
      <div class="customer-list">
        <div
          v-for="(customer, key) in customers || []"
          :key="key"
          :class="selectedCustomer && selectedCustomer.id === customer.id ?'customer-item checked' : 'customer-item'"
          @click="showCustomerProfile(customer)"
        >
          <div class="user-avatar">
            <img :src="customer.avatar"/>
          </div>
          <div class="user-info">{{ customer.name }}</div>
        </div>
      </div>
    </div>
    <div class="customer-main">
      <div v-if="selectedCustomer" class="profile-card">
        <div class="card-title" style="">
          <!-- <div class="profile-name">
            <i class="iconfont icon-zhanghu"></i>
            <div>{{ selectedCustomer.name }}</div>
          </div>
          <div class="profile-avatar">
            <img :src="selectedCustomer.avatar"/>
          </div> -->
          <div style="max-width: 100%;min-width: 570px;">

              <div style="display: flex;">
                  <div style="width: 80px; height: 80px; border-radius: 20px;">
                    <!-- <img src="../../../static/game_icon.jpg" style="width: 100%; height: 100%; border-radius: 20rpx;"> -->
                    <img :src="selectedCustomer.avatar" style="width: 80px; height: 80px; border-radius: 20px;"/>
                  </div>
                  <div style="min-width: 490px;max-width: 100%; height: 80px; padding-left: 20px;">
                    <div class="base_title_show" style="font-size: 15px; color: #222; margin-bottom: 8rpx;">
                      <!-- <uni-tag inverted circle size="small" text="寄售" type="primary"></uni-tag> -->
                      <!-- 【拍卖交易】47500万金=728.17元sdfsdfsdfsdfsdfsdfsdf -->
                      {{selectedCustomer.title}}
                    </div>
                    <div style="color: #666;font-size: 25rpx; margin-top: 10px;">
                      {{selectedCustomer.path_title}}
                    </div>
                    
                  </div>

              </div>

              <div style="min-width: 580px;max-width: 100%;">
                <div style="display: flex;justify-content: right;  font-size: 14px;">
                  <div style="display: flex;justify-content:space-between; width: 300px;">
                    <div>订单编号</div>
                    <div>{{ selectedCustomer.order_no }}</div>
                  </div>
                </div>
                <div style="display: flex;justify-content: right;  font-size: 14px;">
                  <div style="display: flex;justify-content:space-between; width: 300px;">
                    <div>创建时间</div>
                    <div>{{ selectedCustomer.created_at }}</div>
                  </div>
                </div>
                <div style="display: flex;justify-content: right;  font-size: 14px;">
                  <div style="display: flex;justify-content:space-between; width: 300px;">
                    <div>实付金额</div>
                    <div style="color:#ff5c00"><span style="">￥</span><span style="font-size: 18px;">{{ selectedCustomer.sum_price }}</span></div>
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div style="">
          <div style="text-align: center;margin-top: 20px;font-size: 20px;">
            卖家信息
          </div>
          <div class="info-item">
            <div class="info-name">昵 称</div>
            <div class="info-text">{{ selectedCustomer.seller_nick_name }}</div>
          </div>
          <div class="info-item">
            <div class="info-name">邮 箱</div>
            <div class="info-text">{{ selectedCustomer.seller_email }}</div>
          </div>
          <div class="info-item">
            <div class="info-name">手 机</div>
            <div class="info-text">{{ selectedCustomer.seller_mobile }}</div>
          </div>
        </div>

        <div>
          <div style="text-align: center;margin-top: 20px;font-size: 20px;">
            买家信息
          </div>

          <div class="info-item">
            <div class="info-name">昵 称</div>
            <div class="info-text">{{ selectedCustomer.buy_nick_name }}</div>
          </div>
          <div class="info-item">
            <div class="info-name">邮 箱</div>
            <div class="info-text">{{ selectedCustomer.seller_email }}</div>
          </div>
          <div class="info-item">
            <div class="info-name">手 机</div>
            <div class="info-text">{{ selectedCustomer.seller_mobile }}</div>
          </div>
        </div>

        <div class="button-box">
          <button class="card-button" @click="chat(selectedCustomer)">发消息</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import restApi from "../api/restapi";
  import jobApi from "../api/jobApi";

  export default {
    name: "Customers",
    data() {
      return {
        customers: [],
        selectedCustomer: null,
        queryValue: '',
      };
    },
    created(){
        this.getConsultOrderList();
    },
    mounted() {
      //this.customers = restApi.findCustomers();
    },
    methods: {
      showCustomerProfile(customer) {
        this.selectedCustomer = customer;
      },
      chat(customer) {
        this.$router.replace({
          path: '/conversations/chat/'+customer.id,
          query: {
            name: customer.name,
            avatar: customer.avatar,
            room_id: customer.room_id
          }
        });
      },
      search(){
       
       
        this.getConsultOrderList({order_no:  this.queryValue.trim()});
      },
      getConsultOrderList(params = {}){
        jobApi.getConsultOrderList(params).then(res=>{
          if(res.code != '0'){
              return
          }
          this.customers = [];
          let data = res.data;
          data.forEach((item, index) => {
              let row =  {
                  id: 1,
                  name:  item.order_no,
                  avatar: this.BASE_URL + item.icon_image,
                  title: item.title,
                  path_title: item.path_title,
                  created_at: item.created_at,
                  sum_price : item.sum_price,
                  order_no: item.order_no,

                  seller_nick_name: item.seller_nick_name,
                  seller_email:  item.seller_email,
                  seller_mobile:  item.seller_mobile,

                  buy_nick_name: item.buy_nick_name,
                  buy_email: item.buy_email,
                  buy_mobile: item.buy_mobile,
                  room_id: item.room_id
              };
              this.customers.push(row);
          })

        }).catch(err=>{

        })
      }


      // chat(conversation) {
      //   return {
      //     path: '/conversations/chat/'+conversation.id,
      //     query: {
      //       room_id: conversation.room_id,
      //       name: conversation.data.name,
      //       avatar: conversation.data.avatar,
      //     }
      //   }
      // },
    },
  };
</script>

<style scoped>
  .customer {
    width: 100%;
    height: 100%;
    display: flex;
    background: #F7F7F7;
  }

  .customer-left {
    height: 100%;
    border-right: #dbd6d6 1px solid;
    width: 240px;
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
  }

  .customer-tab {
    padding: 20px;
    font-size: 18px;
    border-bottom: 1px solid #eeeeee;
  }

  .customer-list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .customer-item {
    display: flex;
    padding: 5px 10px;
    cursor: pointer;
  }

  .user-avatar {
    width: 45px;
  }

  .user-avatar img {
    width: 45px;
    height: 45px;
    border-radius: 10%;
  }

  .user-info {
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 10px;
    font-size: 15px;
  }

  .customer-left .checked {
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  }

  .customer .customer-main {
    flex: 1;
    background: #FFFFFF;
  }

  .card-title {
    padding: 60px;
    border-bottom: 1px solid #eeeeee;
    /* display: flex; */
    justify-content: space-around;
  }

  .profile-name {
    width: 300px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .profile-name .icon-zhanghu {
    font-size: 26px;
    color: #eeeeee;
    margin-right: 10px;
  }

  .profile-avatar {
    width: 60px;
  }

  .profile-avatar img {
    width: 60px;
    height: 60px;
    border-radius: 10%;
  }

  .profile-card .info-item {
    padding: 10px 30px;
    display: flex;
    justify-content: space-around;
    text-align: left;
    font-size: 14px;
    line-height: 15px;
  }

  .profile-card .info-item .info-name {
    width: 100px;
  }

  .profile-card .info-item .info-text {
    width: 200px;
  }

  .button-box {
    padding: 40px 0;
  }

  .card-button {
    background: #eeeeee;
    color: #000000;
    font-size: 14px;
    border: none;
    display: flex;
    width: 120px;
    height: 35px;
    cursor: pointer;
    border-radius: 5px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }

</style>
